export default () => window.Core.Search.ResultCode;
